import React from 'react';

const galleryImages = [
  "assets/Car-Delivery-Photos/delivery Photo.png",
  "/assets/Car-Delivery-Photos/delivery Photo 2.png",
  "assets/Car-Delivery-Photos/delivery Photo 3.png",
  "assets/Car-Delivery-Photos/delivery Photo 4.png",
];

const Gallery = () => {
  // Duplicate the array to create the infinite scroll effect
  const duplicatedImages = [...galleryImages, ...galleryImages, ...galleryImages];

  return (
    <section className="bg-slate-950 py-16 px-4 sm:px-6 lg:px-8">
      {/* Updated: Main container to match the image */}
      <div className="bg-[#303030] rounded-lg p-8 relative">
        <h2 className="text-3xl font-bold text-white mb-8 uppercase text-center">
          Our <span className="text-yellow-400">Gallery</span>
        </h2>
        
        <div className="gallery-slider-container">
          <div className="gallery-slider-track">
            {duplicatedImages.map((image, index) => (
              <div 
                key={index} 
                className="gallery-image-card flex-shrink-0 mx-4 rounded-lg overflow-hidden shadow-lg transition-all duration-300 ease-in-out hover:scale-105"
              >
                <img src={image} alt={`Gallery Image ${index + 1}`} className="w-full h-full object-cover" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gallery;